module.exports = __webpack_public_path__ + "static/media/profile.c3762003.svg";